export default {
  title: 'Submisions',
  quotes: 'Submisions',
  alliance_submission: 'Alliance submission',
  my_submission: 'My Submisions',
  alliance_offer: 'Alliance offer',
  total_estimation: 'Total',
  back_to_quotes: 'Back to submissions',
  request_change_title: 'Adjustment request.',
  noQuotes: "You haven't created any quotes yet.",
  published_quotes_title: 'MY EXISTING SUBMISSIONS',
  load_more_quotes: 'Load more submissions',
  manage: 'Manage',
  prospectQuotesLabel: 'Prospect quotes',
  prospectQuotesTitle: 'Create a quote project',
  selectProjectLabel: 'Select a project',
  selectProjectPlaceholder: 'Click to see your active prospects',
  create_submission_title: 'Create a submission.',
  create_submission_button: 'Create a new submission',
  pending_requests_empty: 'No request at the moment',
  steps_previous: 'Previous step',
  steps_next: 'Next step',
  offerLabel: 'Offer',
  addAllianceLabel: 'Add an alliance',
  addAlliancePlaceholder: 'Select an alliance',
  createQuoteTitle: 'Create Quote Project',
  allianceSelectionTitle: 'Select Alliance Members',
  createQuote: 'Create Quote',
  viewSubmissionButtonLabel: 'View submission',
  quoteStatus: 'Status',
  childQuoteOfferPending: 'Pending',
  my_submissions: 'My Submissions',
  view_all_my_submissions: 'View all my submissions',
  confirmRetireTitle: 'Confirm retirement',
  confirmActivateButton: 'Activate',
  confirmRetireMessage:
    'Do you really want to retire your submission for the project: {{jobTitle}} ?',
  confirmActivateTitle: 'Confirm activation',
  confirmActivateMessage:
    'Do you really want to activate your submission for the project: {{jobTitle}} ?',
  viewProjectButtonLabel: 'View project',
  quoteRequestInfo: {
    publishedDate: 'Published date',
    submittedDate: 'Submission date',
    projectInfo: 'Project information',
    projectName: 'Project name',
    companyName: 'Company name',
    priceRange: 'Budget',
    dueDate: 'Due date',
    startDate: 'Start date',
    onsite: 'On-site work',
    city: 'Location',
    jobDescription: 'Job offer description',
  },
  createQuoteModal: {
    allianceSelectionTitle: 'Your Alliances',
    addOfferSectionTitle: 'My offer',
    addOfferButtonLabel: 'Add an offer',
    taskTitle: 'Task {{number}}',
    taskNamePlaceholder: 'Task name',
    taskDescriptionLabel: 'Task description',
    typeLabel: 'Type',
    quantityLabel: 'Quantity',
    unitPriceLabel: 'Unit price',
    totalLabel: 'Total',
    addLineButtonLabel: 'Add a line',
    additionalNotesLabel: 'Additional notes',
    changeRequestLabel: 'Change request',
    additionalNotesPlaceholder:
      'Specify your methodology, deadlines or any other relevant information for the client...',
    saveOfferButtonLabel: 'Save',
    savingOfferButtonLabel: 'Saving...',
    pricingType: {
      hourly: 'Hourly',
      flat_rate: 'Flat rate',
      unit: 'Unit',
      fee: 'Fee',
      adjustment: 'Adjustment',
      tax: 'Tax',
    },
    hourlyRateLabel: 'Hourly rate',
    hourlyRatePlaceholder: '50$',
    timeLabel: 'Total hours',
    timePlaceholder: '10',
    descriptionLabel: 'Description',
    totalAmountSectionTitle: 'Total amount',
    myOfferTotalAmountLabel: 'Your total',
    addMyOfferButtonLabel: 'Add my offer',
    addingMyOfferButtonLabel: 'Adding my offer...',
    saveDraftButtonLabel: 'Save draft',
    submitQuoteButtonLabel: 'Submit quote',
    submitAdjustedQuoteButtonLabel: 'Submit adjustment',
    submitQuoteWithCreditButtonLabel: 'Use 1 token and submit quote',
    submitAdjustedQuoteWithCreditButtonLabel: 'Use 1 token and submit adjustment',
    saveAndSubmitButtonLabel: 'Save and submit',
    submittingButtonLabel: 'Submitting...',
    quoteRequestLabel: 'Quote Request',
    offerLabel: 'Offer',
    cancelSubmissionButtonLabel: 'Cancel submission and close',
    backToSubmissionButtonLabel: 'Cancel and return to submission',
    backToSubmissionsButtonLabel: 'Back to submission',
    submitConfirmationTitle: 'Quote submission sent',
    submitConfirmationText: '<bold>{{requesterName}}</bold> will respond soon.',
    submitError: 'An error occurred while submitting the quote',
    unknownErrorCreatingTasks: 'An unknown error occurred while creating the tasks',
    removeAlliancesConfirmTitle: 'Confirm the removal of the alliance',
    removeAlliancesConfirmText:
      'You are about to remove {{name}} from your submission. A message will be sent to him.',
    restoreAllianceButtonLabel: 'Restore alliance',
    submitDisabledNoOffer: 'You must add your offer to submit your quote.',
    submitDisabledChangesNotSaved: 'You must save your changes before submitting your quote.',
    submitDisabledAlliances: 'All alliance members must submit their offer to submit the quote.',
    submitDisabledInsufficientCredits:
      'Insufficient credits. {{count}} token(s) required to submit a quote to a public project.',
    quoteAlreadySubmitted:
      'You can no longer edit this quote because it has already been submitted to the client.',
    unknownInviteAllianceError: 'An unknown error occurred while sending the request.',
    unknownCancelAllianceRequestError: 'An unknown error occurred while cancelling the request.',
    unknownRetireAllianceError: 'An unknown error occurred while retiring the alliance.',
    unknownErrorUpdatingServiceCategory:
      'An unknown error occurred while updating the service category',
    inviteAllianceQuoteTitle: 'Invitation of participation to : <bold>{{jobTitle}}</bold>',
    inviteSentMessage: 'The invitation has been sent to <bold>{{freelancerName}}</bold>.',
    close: 'Close',
    removeAllianceConfirmTitle: 'Remove alliance',
    cancelAllianceConfirmTitle: 'Cancel participation request',
    removeAllianceConfirmText:
      'You are about to remove {{name}} from your submission. They will be notified.',
    cancelAllianceConfirmText:
      'You are about to cancel the participation request sent to {{name}}. They will be notified.',
    showAllianceButtonLabel: 'View alliance',
    removeAllianceButtonLabel: 'Remove alliance',
    loadMoreQuotes: 'Load more submissions',
    sendQuoteAllianceRequest: 'Send request',
    sendingQuoteAllianceRequest: 'Sending request...',
    cancelQuoteAllianceRequest: 'Cancel request',
    cancellingQuoteAllianceRequest: 'Cancelling request...',
    removeFromSubmission: 'Remove from submission',
    removingFromSubmission: 'Removing from submission...',
    quantityColumnHeader: 'Quantity',
    savingButtonLabel: 'Saving...',
    taskDescriptionColumnHeader: 'Task description',
    taskDescriptionPlaceholder: 'Task description',
    totalAmountLabel: 'Grand total',
    typeColumnHeader: 'Type',
    unitPriceColumnHeader: 'Unit price',
    backToQuote: 'Back to submission',
    inviteMessagePlaceholder: 'Your message',
    inviteSentTitle: 'Request sent',
  },
  requestChangeError:
    'An unknown error occurred while requesting an adjustment. Please try again or contact support.',
  errors: {
    jobNotAvailable:
      'You can no longer submit your quote because the associated project is no longer available.',
    quoteAllianceRetired:
      'You can no longer submit your quote because your invitation was cancelled.',
    submitError: 'An unknown error occurred while submitting. Please try again or contact support.',
    insufficientCredits: 'Insufficient credits',
  },
  teamMembers: 'Team Members',
  acceptQuote: 'Accept submission',
  declineQuote: 'Decline submission',
  sub_total: 'Sub-total',
  time: 'Time',
  quote_change_message_for_label: 'Your messqge for {{name}}',
  quote_change_message_hint:
    'To request an adjustment from <bold>{{name}}</bold>, please provide your explanation.',
  quote_change_notification: '{{name}} will be notified',
  quote_change_request_sent: 'Adjustment request sent',
  change_has_been_requested: 'Change has been requested',
  request_changes: 'Request changes',
  requestChangeMessagePlaceholder: 'Your explanation',
  quote_ownership_statuses: {
    principal: 'Principal submission',
    alliance: 'Alliance submission',
  },
  pendingRequestsTitle: 'Pending requests',
  viewProspectsButton: 'View my contacts',
  bigStepsTitle: 'The big steps',
  bigStepsSubtitle: "To get started on the right foot, here's what you need to know!",
  stepTitle: 'Fill out the form',
  stepDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  needHelpText: 'Need help?',
  callToActionButton: 'Call to action',
  creating: 'Creating...',
  retry: 'Retry',
  createQuoteErrorTitle: 'Error creating quote',
  createQuoteErrorHint: 'An error occurred while creating your quote. Please try again.',
  print: {
    printButton: 'Print',
    documentLabel: 'Submission',
    principalLabel: 'Primary bidder',
    freelancerLabel: 'Bidder',
    tasksLabel: 'Task breakdown',
    footer: 'Document generated on {{date}} via Pigeons.',
    notFound: 'Submission not found or access denied.',
  },
  bigSteps: {
    title: 'Main steps',
    subtitle: 'To get started, here is everything you need to know!',
    steps: {
      one: {
        title: 'Review the project',
        description: 'Get to know the mandate, expectations, and key dates.',
      },
      two: {
        title: 'Present your proposal',
        description: 'Describe how you would carry out the mandate and at what price.',
      },
      three: {
        title: 'Submit your quote',
        description: 'The recruiter receives it and can contact you quickly.',
      },
    },
    needHelp: 'Need help?',
    cta: 'Find a project',
  },
  my_offer: 'My offer',
  grand_total: 'Grand total',
  no_alliance: 'No alliance',
  activating: 'Activating...',
  retiring: 'Retiring...',
  modify: 'Edit',
  edit_submission: 'Edit my submission',
  cancel_submission: 'Cancel my offer',
  confirmRetireButton: 'Retire',
  quoteActivateError: 'Failed to activate submission',
  quoteRetireError: 'Failed to retire submission',
  your_alliances: 'Your alliances',
  team: 'Team',
  tasks: 'Tasks',
  role: 'Role',
  close: 'Close',
  addOfferSectionTitle: 'My offer',
} as const;
